module.exports = {"410523100":"城关镇","410523101":"菜园镇","410523102":"任固镇","410523103":"五陵镇","410523104":"宜沟镇","410523105":"白营镇","410523106":"伏道镇","410523107":"韩庄镇","410523108":"古贤镇","410523203":"瓦岗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410523.json
// module id = 1692
// module chunks = 0